import { render, staticRenderFns } from "./PayCertificateDialog.vue?vue&type=template&id=4c8b8737&scoped=true"
import script from "./PayCertificateDialog.vue?vue&type=script&lang=js"
export * from "./PayCertificateDialog.vue?vue&type=script&lang=js"
import style0 from "./PayCertificateDialog.vue?vue&type=style&index=0&id=4c8b8737&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b8737",
  null
  
)

export default component.exports